module.exports = __webpack_public_path__ + "static/media/logo.a02b6720.png";